import {
  IHealthPointTransactionExtendedData,
  isHealthPointTransactionExtendedData,
  TransactionStatus,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import { TransactionHelpers } from '../../../transaction-helpers';

export class VoidHealthPointTransaction
  implements ITransactionAction<IHealthPointTransactionExtendedData>
{
  icon = 'block';
  label = 'Void';
  tooltip = 'Void if claim has been manually cancelled via health fund';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isHealthPointTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IHealthPointTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isHealthPointTransactionExtendedData
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return (
          transaction.type === TransactionType.Incoming &&
          transaction.status !== TransactionStatus.Failed
        );
      })
    );
  }

  async do(
    data: ITransactionActionsData<IHealthPointTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    try {
      await this._actions.cancel(
        data.invoice,
        data.latestTransaction,
        'Void Health Claim'
      );
    } finally {
      this.inProgress$.next(false);
    }
  }
}
